<template xmlns="http://www.w3.org/1999/html">

  <!--开始扫二维码和输入二维码页面-->
  <div id="background" style="width: 100vw;
    position:fixed;
    background: url(/static/images/ainiu/bg.png) no-repeat;
    background-attachment:fixed;
    background-size:cover;
    height: 100vh;
    overflow: hidden;display: flex;flex-direction: column;align-items: center;">
    <img src="/static/images/ainiu/logo.png" style="width: 70vw;z-index: 1;margin-top: 11vh;" />

    <div style="width: 90vw;height: 55vh;background-color: white;border-radius: 10px;z-index: 2;
    display: flex;flex-direction: column;align-items: center;justify-content: center;">
      <span style="font-size: 4.4vw;">1. 点击扫一扫查询</span>
      <img src="/static/images/ainiu/scan.png" style="width: 40%;z-index: 1;margin-top: 3vh;" @click="openScan" />
      <span style="font-size: 4.4vw;margin-top: 5vh;">2. 刮开涂层输入数码查询</span>
      <div class="input-container">
        <input type="text" v-model="antiCode" placeholder="请输入16位防伪码" class="anti-code-input" />
        <button class="confirm-button" @click="queryAnti">查询</button>
      </div>
    </div>


    <img src="/static/images/ainiu/bottom.png" style="width: 100vw;position: absolute;bottom: 0;z-index: 1;" />

  </div>
  <!--结束扫二维码和输入二维码页面-->

</template>

<style scoped>
.input-container {
  display: flex;
  margin-top: 2vh;
  align-items: center;
  border: 2px solid rgb(55, 125, 217);
  border-radius: 4px;
  overflow: hidden;
  width: 90%;
  /* Adjust width as needed */
}

.anti-code-input {
  border: none;
  padding: 1vh 0px 1vh 12px;
  flex: 1;
  font-size: 4vw;
}

.confirm-button {
  background-color: rgb(55, 125, 217);
  /* 深绿色背景 */
  color: white;
  border: none;
  padding: 8px 25px;
  font-size: 16px;
  cursor: pointer;
  outline: none;
}

.confirm-button:hover {
  background-color: rgb(55, 125, 217);
  /* Slightly darker green on hover */
}
</style>


<script>
import { getJSSDK, } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      eno: "",
      antiCode:""
    }
  },
  methods: {
    async queryAnti() {
      if (this.antiCode == "") {
        alert("请输入16位防伪码进行查询验证")
        return;
      }
      this.$router.replace({
        path: '/ainiu',
        query: {
          c: this.antiCode
        }
      })
    },
    openScan() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          this.$router.replace({
            path: '/ainiu',
            query: {
              c: scanQRCode
            }
          })
        }
      });
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wxe9b46393a0cb8eed").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted: function () {
    this.getWxJs()
  },
  created: function () {
    const params = this.$route.query;
    const eno = params.eno;
    if (eno != null && eno != undefined) {
      this.eno = eno
    } else {
      alert("请使用正确入口地址进行查询");
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AiNiu/Scan.vue